import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchTinyurlData, createTinyurl } from "../../features/tinyurl/tinyurlSlice";
import { ToastContainer, toast } from "react-toastify";

const TinyurlModal = ({ showUtmModal, setShowUtmModal }) => {
    const dispatch = useDispatch();
    const [utmForm, setUtmForm] = useState({
        main_url: "",
        utm_source: "",
        utm_medium: "",
        utm_campaign: "",
        utm_term: "",
        utm_content: ""
    });

    const handleUtmChange = (e) => {
        const { name, value } = e.target;
        setUtmForm((prev) => ({
        ...prev,
        [name]: value
        }));
    };

    const initialUtmForm = {
        main_url: "",
        utm_source: "",
        utm_medium: "",
        utm_campaign: "",
        utm_term: "",
        utm_content: ""
    };

    const handleUtmSubmit = async () => {
        try {
            await dispatch(createTinyurl(utmForm)).unwrap();
            toast.success("Tiny URL created successfully ✅");
            await dispatch(fetchTinyurlData());
            setUtmForm(initialUtmForm);
            setShowUtmModal(false);
        } catch (err) {
            if (err?.message === "This URL already exists.") {
                toast.error(err.message || "This URL already exists.");
            } else {
                toast.error(err?.message || "Something went wrong");
            }
        }
    };

  return (
    <Modal
      size="lg"
      backdrop="static"
      keyboard={false}
      show={showUtmModal}
      onHide={() => setShowUtmModal(false)}
    >
      <Modal.Header closeButton className="bg-light p-3">
        <Modal.Title>Create Tiny URL</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="row g-3">
          <div className="col-lg-12">
            <div>
              <label className="form-label">
                Main URL <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                name="main_url"
                className="form-control"
                placeholder="Enter Main URL"
                value={utmForm.main_url}
                onChange={handleUtmChange}
              />
            </div>
          </div>

          <div className="col-lg-6">
            <label className="form-label">UTM Source</label>
            <input
              type="text"
              name="utm_source"
              className="form-control"
              placeholder="utm_source"
              value={utmForm.utm_source}
              onChange={handleUtmChange}
            />
          </div>

          <div className="col-lg-6">
            <label className="form-label">UTM Medium</label>
            <input
              type="text"
              name="utm_medium"
              className="form-control"
              placeholder="utm_medium"
              value={utmForm.utm_medium}
              onChange={handleUtmChange}
            />
          </div>

          <div className="col-lg-6">
            <label className="form-label">UTM Campaign</label>
            <input
              type="text"
              name="utm_campaign"
              className="form-control"
              placeholder="utm_campaign"
              value={utmForm.utm_campaign}
              onChange={handleUtmChange}
            />
          </div>

          <div className="col-lg-6">
            <label className="form-label">UTM Term</label>
            <input
              type="text"
              name="utm_term"
              className="form-control"
              placeholder="utm_term"
              value={utmForm.utm_term}
              onChange={handleUtmChange}
            />
          </div>

          <div className="col-lg-6">
            <label className="form-label">UTM Content</label>
            <input
              type="text"
              name="utm_content"
              className="form-control"
              placeholder="utm_content"
              value={utmForm.utm_content}
              onChange={handleUtmChange}
            />
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="hstack gap-2 justify-content-end">
          <Button
            variant="danger"
            className="btn btn-light"
            onClick={() => setShowUtmModal(false)}
          >
            Close
          </Button>
          <Button
            variant="success"
            className="btn btn-success"
            onClick={handleUtmSubmit}
          >
            Save
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default TinyurlModal;
